var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 4.50001H19.1666V6.33334H17.3333V18.25C17.3333 18.4931 17.2367 18.7263 17.0648 18.8982C16.8929 19.0701 16.6597 19.1667 16.4166 19.1667H3.58325C3.34014 19.1667 3.10698 19.0701 2.93507 18.8982C2.76316 18.7263 2.66659 18.4931 2.66659 18.25V6.33334H0.833252V4.50001H5.41658V1.75001C5.41658 1.5069 5.51316 1.27374 5.68507 1.10183C5.85698 0.929921 6.09014 0.833344 6.33325 0.833344H13.6666C13.9097 0.833344 14.1429 0.929921 14.3148 1.10183C14.4867 1.27374 14.5833 1.5069 14.5833 1.75001V4.50001ZM15.4999 6.33334H4.49992V17.3333H15.4999V6.33334ZM7.24992 9.08334H9.08325V14.5833H7.24992V9.08334ZM10.9166 9.08334H12.7499V14.5833H10.9166V9.08334ZM7.24992 2.66668V4.50001H12.7499V2.66668H7.24992Z",
    fill: "#008662"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.6678298a7cc92a6fd0a6d4aa749ff87b.svg";
export { ForwardRef as ReactComponent };